import { BorrowerOnboardingDetails, CashInCashOutMethod, Income } from '@nemuru-eng/js-api-client';
import ibanLib from 'iban';

export const ValidationDeclaredDataMap = {
  toDocumentIdData: (onboardingDetails: BorrowerOnboardingDetails) => {
    const documentNumber = onboardingDetails.userDetails?.documentId?.documentNumber;
    const documentType = onboardingDetails.userDetails?.documentId?.documentType;

    return { documentNumber, documentType };
  },

  toAccountData: (
    onboardingDetails: BorrowerOnboardingDetails,
    cashInCashOutMethod: CashInCashOutMethod | undefined,
  ) => {
    const firstName = onboardingDetails.userDetails?.documentId?.fullName.firstName;
    const lastName = onboardingDetails.userDetails?.documentId?.fullName.lastName;

    const iban = cashInCashOutMethod?.accountNumber
      ? (ibanLib.printFormat(cashInCashOutMethod?.accountNumber) as string)
      : undefined;

    return { firstName, lastName, iban };
  },

  toIncomeData: (onboardingDetails: BorrowerOnboardingDetails, income: Income | undefined) => {
    const companyName = onboardingDetails.userDetails?.professionalDetails?.companyInfo?.name;
    const employmentStatus = onboardingDetails.userDetails?.professionalDetails?.employmentStatus;
    const seniorityMonths = onboardingDetails.userDetails?.professionalDetails?.companyInfo?.seniorityMonths;
    const seniorityYears = onboardingDetails.userDetails?.professionalDetails?.companyInfo?.seniorityYears;

    const currentDate = new Date();
    const seniorityDate =
      seniorityYears !== undefined && seniorityMonths !== undefined
        ? new Date(
            currentDate.getFullYear() - seniorityYears,
            currentDate.getMonth() - seniorityMonths,
            currentDate.getDate(),
          )
        : undefined;

    const annualNetIncome = income?.netIncome?.annualNetIncome;
    const monthlyNetIncome = income?.netIncome?.monthlyNetIncome;
    const numberOfPayments =
      annualNetIncome === undefined || monthlyNetIncome === undefined
        ? undefined
        : Math.floor(annualNetIncome.amount / monthlyNetIncome.amount);

    return { companyName, seniorityDate, annualNetIncome, numberOfPayments, monthlyNetIncome, employmentStatus };
  },
};
